import i18n from 'i18n-js';

import {
  CountdownFortniteBus,
  CountdownFortniteIsland,
  CountdownFortniteLlama,
  FortniteSimple,
} from '../../components';

import { TEMPLATES_TITLES } from '../templates';

export const FORTNITE_COMPONENTS = {
  [TEMPLATES_TITLES.COUNTDOWN_FORTNITEBUS]: CountdownFortniteBus,
  [TEMPLATES_TITLES.COUNTDOWN_FORTNITEISLAND]: CountdownFortniteIsland,
  [TEMPLATES_TITLES.COUNTDOWN_FORTNITELLAMA]: CountdownFortniteLlama,
  [TEMPLATES_TITLES.FORTNITE_SIMPLE]: FortniteSimple,
};

export const FORTNITE_DESIGNS_DATA = {
  [TEMPLATES_TITLES.COUNTDOWN_FORTNITEBUS]: {
    design: {
      styles: [
        {
          id: 1,
          title: i18n.t('screens.builder.design.timer'),
          value: 'timer',
          items: [
            {
              id: 100,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 101,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 102,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 103,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 20,
              max: 80,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 104,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
        {
          id: 2,
          title: i18n.t('screens.builder.design.title'),
          value: 'title',
          items: [
            {
              id: 200,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 201,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 202,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 20,
              max: 80,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 203,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
      ],
    },
  },
  [TEMPLATES_TITLES.COUNTDOWN_FORTNITEISLAND]: {
    design: {
      styles: [
        {
          id: 1,
          title: i18n.t('screens.builder.design.timer'),
          value: 'timer',
          items: [
            {
              id: 100,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 101,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 102,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 103,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 60,
              max: 120,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 104,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
        {
          id: 2,
          title: i18n.t('screens.builder.design.title'),
          value: 'title',
          items: [
            {
              id: 200,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 201,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 202,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 20,
              max: 80,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 203,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
      ],
    },
  },
  [TEMPLATES_TITLES.COUNTDOWN_FORTNITELLAMA]: {
    design: {
      styles: [
        {
          id: 1,
          title: i18n.t('screens.builder.design.timer'),
          value: 'timer',
          items: [
            {
              id: 100,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 101,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 102,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 103,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 40,
              max: 120,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 104,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
        {
          id: 2,
          title: i18n.t('screens.builder.design.title'),
          value: 'title',
          items: [
            {
              id: 200,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 201,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 202,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 20,
              max: 80,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 203,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
      ],
    },
  },
  [TEMPLATES_TITLES.FORTNITE_SIMPLE]: {
    design: {
      styles: [
        {
          id: 1,
          title: i18n.t('screens.builder.design.match'),
          value: 'match',
          items: [
            {
              id: 100,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 101,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
          ],
        },
        {
          id: 2,
          title: i18n.t('screens.builder.design.rank'),
          value: 'rank',
          items: [
            {
              id: 200,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 201,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
          ],
        },
      ],
    },
  },
};

export default {
  FORTNITE_COMPONENTS,
  FORTNITE_DESIGNS_DATA,
};
